import { useEffect } from "react";
import { ThemeProvider } from "@mui/material";
import { UserLayout } from "../UserLayout";
import { darkTheme } from "../../../theme/dark";
import {
  ChatWithBoActivityDetailSection,
  ChatWithBoActivityHeaderSection,
  useLocation,
  useNavigate,
} from "../../../modules";

export const ChatWithBoActivity = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    navigate(pathname, {
      tab: "1",
    });
  }, [navigate, pathname]);

  return (
    <ThemeProvider theme={darkTheme}>
      <div className="dark">
        <UserLayout fillViewport banner={<ChatWithBoActivityHeaderSection />}>
          <ChatWithBoActivityDetailSection />
        </UserLayout>
      </div>
    </ThemeProvider>
  );
};
